import styled from "styled-components";
import { motion } from "framer-motion";

export const SeriesDisplayContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`
export const CollectionStats = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;

    div {
        flex-grow: 1;
    }
`
export const DisplayHeader = styled.div`
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;

    h3 {
        font-size: 16px;
        opacity: 0.4;
        padding: 8px 0px;
    }
`
export const BodyContainer = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
`
export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`
export const CardsDisplayContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
    width: 100%;
`
export const LeftFilterContainer = styled.div`
    display: flex;
    gap: 16px;
`
export const ChecklistControls = styled.div`
    display: flex;
    justify-content: space-between;

    label {
        font-size: 12px;
        font-weight: 600;
    }

    select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(20px);
        /* Custom dropdown arrow */
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23FFFFFF' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 8px center;
        background-size: 12px;
        border: 1px solid rgba(255,255,255,0.4);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        height: 44px;
        outline: none;
        padding: 0px 32px 0px 8px;
        transition: background-color 0.15s ease-out;

        &:hover {
            background-color: rgba(255, 255, 255, 0.15);
        }

        &:focus {
            background-color: rgba(255, 255, 255, 0.15);
            border: 2px solid rgba(255,255,255,0.6);
        }

        option {
            background: rgba(0, 0, 0, 0.9);
            color: #FFFFFF;
            padding: 8px;
        }
    }
`
export const ControlContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`
export const InputField = styled.input`
    background: none;
    border: 1px solid rgba(255,255,255,0.4);
    border-radius: 8px;
    box-sizing: border-box;
    color: #FFFFFF;
    font-weight: 600;
    height: 44px;
    padding: 8px;
    width: 50%;
    min-width: 480px;

    &:focus {
        border: 2px solid rgba(255,255,255,0.4);
        outline: none;
    }

    &::placeholder {
        color: rgba(255,255,255,0.4);
    }
`
export const CardsDisplay = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    width: 100%;
    transition: 0.2s ease-out;
    align-items: start;
`
export const QueuedCardsContainer = styled(motion.div)`
    width: 50%;
    position: ${props => props.$fixed ? 'sticky' : 'relative'};
    top: ${props => props.$fixed ? '24px' : 'auto'};
    z-index: ${props => props.$fixed ? '100' : 'auto'};
    max-height: ${props => props.$fixed ? 'calc(100vh - 96px)' : 'auto'};
    overflow-y: ${props => props.$fixed ? 'auto' : 'visible'};
    align-self: flex-start;
`
export const FixedActionButtonsContainer = styled.div`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 1000;
    padding: 16px 24px;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
`